/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography } from '@coursera/cds-core';

/*
 * hierarchy assumptions:
 * - page has h1
 * - card title is h2
 * - card subheadings are h3
 */

export const CardTitle: React.FC = (props) => (
  <Typography
    variant="h1"
    component="h2"
    css={css`
      color: #335475;
      margin: 0;
    `}
  >
    {props.children}
  </Typography>
);

export const SkillCaption: React.FC = (props) => (
  <Typography
    variant="h2"
    component="h3"
    css={css`
      margin: var(--cds-spacing-300) 0;
    `}
  >
    {props.children}
  </Typography>
);
